/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateOrganizationActions, CreateOrganizationActionTypes, CreateOrganizationState } from './types';

export const initialState: CreateOrganizationState = {
  isOpen: false,
};

export function createOrganization(
  state = initialState,
  action: CreateOrganizationActionTypes,
): CreateOrganizationState {
  switch (action.type) {
    case CreateOrganizationActions.OPEN_CREATE_ORGANIZATION_OVERLAY:
      return {
        ...state,
        isOpen: true,
      };
    case CreateOrganizationActions.CLOSE_CREATE_ORGANIZATION_OVERLAY:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
